export default "__VITE_ASSET__6f7ddcf2__"